module.exports = __webpack_public_path__ + "img/logo.885669df.png";